import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    fetchUsersStart(state) {
      state.status = 'loading';
    },
    fetchUsersSuccess(state, action) {
      state.status = 'succeeded';
      state.users = action.payload;
    },
    fetchUsersFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    createUser(state, action) {
      state.users.push(action.payload);
    },
    updateUser(state, action) {
      const { id, updatedUser } = action.payload;
      const existingUser = state.users.find((user) => user.id === id);
      if (existingUser) {
        Object.assign(existingUser, updatedUser);
      }
    },
    deleteUser(state, action) {
      const id = action.payload;
      state.users = state.users.filter((user) => user.id !== id);
    },
  },
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  createUser,
  updateUser,
  deleteUser,
} = usersSlice.actions;

export default usersSlice.reducer;

export const selectAllUsers = (state) => state.users.users;